import { Component } from '@angular/core';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';
import { SetupWizardClientSelector } from '../../../ui/admin/setup-wizard/setup-wizard-client-selector/setup-wizard-client-selector';

@Component({
	selector: 'app-setup-wizard-client-picker',
	imports: [SetupWizardClientSelector, BreadcrumbsComponent],
	standalone: true,
	templateUrl: './setup-wizard-client-picker.html',
	styleUrl: './setup-wizard-client-picker.scss',
})
export class SetupWizardClientPicker {}
